import {createAsyncThunk} from '@reduxjs/toolkit';
import {SetStateAction} from 'react';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {CompWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import {setIsUnsavedChangesMade} from 'common/src/modules/creativeTemplates/store/creativeTemplatePage/creativeTemplateTrackChanges/creativeTemplateTrackChanges.slice';
import updateMoviesThunk from './updateMoviesThunk';
import {RootState} from 'common/src/redux/store';
import {getActiveFormat} from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/utils/getActiveFormat';

interface UpdateCompsParams {
  compsUpdate: SetStateAction<Record<string, CompWithWorkingProps>>;
  activeFormat?: string;
  replaceState?: boolean;
}

const updateComps = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/updateComps`,
  async (
    {compsUpdate, activeFormat, replaceState = false}: UpdateCompsParams,
    {dispatch, getState},
  ): Promise<void> => {
    const state = getState() as RootState;
    const workingFormat = activeFormat || getActiveFormat();
    const currentMovies = state.creativeTemplatePage.formatMovies.movies;
    const oldComps = currentMovies[workingFormat] || {};
    const newComps = typeof compsUpdate === 'function' ? compsUpdate(oldComps) : compsUpdate;

    const newMovies = {
      ...currentMovies,
      [workingFormat]: newComps,
    };

    await dispatch(
      updateMoviesThunk({
        moviesUpdate: newMovies,
        replaceState,
        activeFormat: workingFormat,
      }),
    );

    if (!replaceState) {
      dispatch(setIsUnsavedChangesMade(true));
    }
  },
);

export default updateComps;
